export default "__VITE_ASSET__smhNyksE__"